
    import { mapGetters } from 'vuex';
    import clampjs from 'clamp-js';
    import JobViewMixin from '~/components/JobView/Mixins/JobViewMixin';
    import CompanyCarouselLightbox from '@/components/Company/CompanyCarouselLightbox';
    import CompanyEEO from '@/components/Company/CompanyEEO';
    import JobViewBrandVisual from '@/components/JobView/JobViewBrandVisual';

    export default {
        name: 'JobViewCompany',

        components: {
            CompanyCarouselLightbox,
            CompanyEEO,
            JobViewBrandVisual,
        },

        mixins: [JobViewMixin],

        props: {
            simple: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isCompanyTextActive: false,
            };
        },

        computed: {
            ...mapGetters('brand', {
                $_brandSector: 'brandSector',
                $_brandIndustry: 'brandIndustry',
            }),
        },

        mounted() {
            this.clampBrandContent('100px');
        },

        methods: {
            clampBrandContent(height) {
                if (this.$_brand.brand_content) {
                    clampjs(this.$refs.brandContent, { clamp: height });
                }
            },
            companyTextToggle() {
                this.isCompanyTextActive = !this.isCompanyTextActive;
                if (this.isCompanyTextActive) {
                    this.clampBrandContent('3000px');
                } else {
                    this.clampBrandContent('100px');
                }
            },
        },
    };
